<template>
  <div class="row row-scheduler" ref="content">
    <div class="col-lg-12">
      <div class="panel-body">
        <div class="row">
          <div class="col">
            <div ref="sheduler" class="scheduler-wrapper"></div>
          </div>

          <div class="side-panel col-lg-2 col-md-3 pl-0 pr-0" v-show="showSchedule">
            <div id="external-events">
              <grid-generator
                v-if="gridDef"
                :page="gridDef.code"
                :idStructure="gridDef.idStructure"
                :showH1="false"
                :showH1OnOwnRow="true"
                :rowClickEmit="true"
                @rowClick="rowClick"
                ref="grid"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <modal
      name="test"
      height="auto"
      :width="1000"
      :scrollable="true"
      :adaptive="true"
      :clickToClose="false"
      :draggable="modalDraggable"
      @closed="modalClosed"
    >
      <scheduler-event-form
        v-if="modalDefArgs && config"
        :eventValueObject="eventValueObject"
        :resourceCollection="resources"
        :defArgs="modalDefArgs"
        :moveCalRec="moveCalRec"
        @removeEvent="removeEventListener"
        @updateEvent="updateEventListener"
        @cancel="cancelListener"
      />
    </modal>
  </div>
</template>

<script>
import { Calendar } from '@fullcalendar/core'
import timeline from '@fullcalendar/timeline'
import resourceTimeline from '@fullcalendar/resource-timeline'
import interactionPlugin, { Draggable } from '@fullcalendar/interaction'
import bootstrap from '@fullcalendar/bootstrap'
import allLocale from '@fullcalendar/core/locales-all'
import SchedulerResource from '../../../model/resource/scheduler.resource'
import { SchedulerResourceValueObject } from '../../../model/value-objects/scheduler-resource.value-object'
import { SchedulerEventValueObject } from '../../../model/value-objects/scheduler-event.value-object'
import SchedulerEventForm from '../../widgets/scheduler-event-form'
import Button from '../../grids/renderers/grid-form/elements/button'
import CalendarTranslator from '../../../model/translator/CalendarTranslator'
import { formatWeekTitleDate } from '../../../utils/calendar.utils'
import { PrepareTooltipData } from '../../../model/prepareTooltipData'
import DefinitionGetter from '../../../model/resource/getter/definitions-getter'
import Definition from '../../../model/entity/Definition'
import GridGenerator from '../../grids/grid-generator'
import DatetimeParser from '../../../model/parser/datetime-parser'

export default {
  name: 'scheduler',
  components: { Button, SchedulerEventForm, GridGenerator },

  props: {
    menuField: {
      type: Object,
      default: () => {
        return null
      }
    }
  },

  data () {
    return {
      calendar: undefined,
      modalDraggable: true,
      resources: [],
      eventCollection: [],
      eventFilters: {
        view_ended_activity: 1,
        view_ended_task: 1
      },
      resourceFilters: {
        view_resource: 1,
        view_activity: 1,
        view_user_group: 1,
        search_keyword: null
      },
      config: undefined,
      eventValueObject: undefined,
      taskEventCalendar: undefined,
      oldCalendarEvent: undefined,
      tooltipRenderer: new PrepareTooltipData(),
      def: null,
      page: this.$route.params.page,
      idStructure: this.$route.params.idStructure,
      gridDef: null,
      modalDefArgs: null,
      moveCalRec: null,
      autoRefresInterval: undefined,
      tooltipTimeout: undefined,
      start: new Date(),
      end: new Date(),
      showSchedule: true
    }
  },

  async created () {
    await this.initDef()

    const contentWidth = this.$refs.content.clientWidth

    if (contentWidth < 968) {
      this.modalDraggable = false
    }
  },

  async mounted () {
    let resourceId

    this.config = await SchedulerResource.getConfig()
    await this.refreshResources()

    this._initAutoRefresh()

    var containerEl = document.getElementById('external-events')

    new Draggable(containerEl, {
      itemSelector: '.product-columns',
      eventData: function (eventEl) {
        return {
          title: eventEl.dataset.title,
          id: eventEl.dataset.id,
          duration: eventEl.dataset.duration,
          extendedProps: {
            duration: parseInt(eventEl.dataset.duration)
          }
        }
      }
    })

    this.calendar = new Calendar(this.$refs.sheduler, {
      schedulerLicenseKey: 'GPL-My-Project-Is-Open-Source',
      plugins: [timeline, resourceTimeline, interactionPlugin, bootstrap],
      themeSystem: 'bootstrap',
      header: {
        left: 'filterViewResource,filterViewActivity,filterViewUserGroup | filterViewEndedActivity,filterViewEndedTask',
        center: 'prev,title,next,switchDay,today | resourceTimelineDay,resourceTimelineWeek,resourceTimelineMonth',
        right: 'toggleSchedule'
      },

      locales: [allLocale],
      locale: this.$user.languageCode.toLowerCase(),
      defaultView: this.config.defaultView,
      resourceGroupField: SchedulerResourceValueObject.tResourceTypeName,
      editable: true,
      displayEventTime: false,
      minTime: this.config.minTime,
      maxTime: this.config.maxTime,
      height: 'auto',
      nowIndicator: true,
      resourceAreaWidth: '20%',
      firstDay: 1,
      buttonText: {
        today: this.$translate.text('sched_today'),
        day: this.$translate.text('sched_day'),
        month: this.$translate.text('sched_month')
      },
      eventConstraint: {
        start: this.config.minTime,
        end: this.config.maxTime
      },
      titleFormat: {
        month: 'long',
        year: 'numeric',
        day: 'numeric',
        weekday: 'long'
      },
      views: {
        resourceTimelineDay: {
          slotLabelFormat: {
            hour: 'numeric',
            minute: '2-digit',
            omitZeroMinute: false,
            meridiem: false,
            hour12: false
          },
          slotDuration: '00:15:00',
          navLinks: false
        },
        resourceTimelineWeek: {
          titleFormat: (date) => {
            return formatWeekTitleDate(date)
          },
          buttonText: this.$translate.text('sched_weeks'),
          duration: { weeks: 2 },
          slotDuration: { days: 1 },
          slotLabelFormat: {
            month: '2-digit',
            day: '2-digit',
            weekday: 'narrow'
          },
          slotWidth: 150
        },
        resourceTimelineMonth: {
          titleFormat: {
            month: 'long',
            year: 'numeric'
          },
          slotWidth: 150
        }
      },
      resources: (fetchInfo, successCallback, failureCallback) => {
        successCallback(this.resources.toCalendarObjects(this.$translate, this.resourceFilters))
      },
      resourceLabelText: this.$translate.text('sched_resource_title'),
      resourceOrder: 'tResourceTypeName', // ROWNUMBER
      drop: (args) => {
        resourceId = args.resource.id
      },
      eventReceive: async (info) => {
        if (resourceId.toString().includes('l')) {
          info.event.remove()
          return
        }
        this.eventValueObject = SchedulerEventValueObject.fromCalendarObject(info.event, resourceId, info.view.type)
        this.moveCalRec = this.config.schedulerCalRec
        this.modalDefArgs = {
          code: this.def._data.Fields[0].Code,
          idtEntityStructureFrom: this.def.idStructure
        }
        this.$modal.show('test')
      },
      eventClick: async (info) => {
        this.moveCalRec = null
        this.eventValueObject = SchedulerEventValueObject.fromCalendarObject(info.event)
        this.modalDefArgs = {
          code: info.event.extendedProps.entityCode,
          idtEntityStructureFrom: info.event.extendedProps.idtEntity
        }
        if (this.modalDefArgs.code) {
          this.$modal.show('test')
        }
        this.setEventId(info.event._def.publicId)
      },
      eventDrop: async (eventDropInfo) => {
        const resourceId = eventDropInfo.newResource ? eventDropInfo.newResource.id : parseInt(
          eventDropInfo.event.extendedProps.propResourceId)
        this.eventValueObject = SchedulerEventValueObject.fromCalendarObject(
          eventDropInfo.event,
          resourceId,
          null,
          eventDropInfo.oldResource ? eventDropInfo.oldResource.id : null
        )
        this.oldCalendarEvent = eventDropInfo.oldEvent
        this.moveCalRec = this.config.schedulerCalRec
        this.modalDefArgs = {
          code: eventDropInfo.event.extendedProps.entityCode,
          idtEntityStructureFrom: eventDropInfo.event.extendedProps.idtEntity
        }
        if (this.modalDefArgs.code) {
          this.$modal.show('test')
        }
      },
      eventResize: async (eventDropInfo) => {
        const resourceId = eventDropInfo.newResource ? eventDropInfo.newResource.id : parseInt(
          eventDropInfo.event.extendedProps.propResourceId)
        this.eventValueObject = SchedulerEventValueObject.fromCalendarObject(eventDropInfo.event, resourceId)
        this.moveCalRec = this.config.schedulerCalRec
        this.oldCalendarEvent = eventDropInfo.oldEvent
        this.modalDefArgs = {
          code: eventDropInfo.event.extendedProps.entityCode,
          idtEntityStructureFrom: eventDropInfo.event.extendedProps.idtEntity
        }
        if (this.modalDefArgs.code) {
          this.$modal.show('test')
        }
      },
      select: async (eventDropInfo) => {
        const resourceId = eventDropInfo.resource.id
        eventDropInfo.extendedProps = {}
        this.eventValueObject = SchedulerEventValueObject.fromCalendarObject(eventDropInfo, resourceId)
        this.moveCalRec = this.config.schedulerCalRec
        this.oldCalendarEvent = undefined
        this.modalDefArgs = {
          code: eventDropInfo.event.extendedProps.entityCode,
          idtEntityStructureFrom: eventDropInfo.event.extendedProps.idtEntity
        }
        if (this.modalDefArgs.code) {
          this.$modal.show('test')
        }
      },
      eventDragStart: (info) => {
        clearTimeout(this.tooltipTimeout)
      },
      navLinks: true,
      navLinkDayClick: (date) => {
        this.calendar.changeView('resourceTimelineDay', date.toISOString())
      },

      // Inicializace tooltipů po renderu hlavičky
      viewSkeletonRender: (info) => {
        setTimeout(() => {
          this.initializeTooltips()
        }, 100)
      },

      datesRender: (info) => {
        this.start = info.view.activeStart
        this.end = info.view.activeEnd
        this.refreshData()

        for (const el of info.el.querySelectorAll('a.fc-cell-text')) {
          const date = JSON.parse(el.dataset.goto).date
          el.onclick = () => {
            setTimeout(
              () => {
                this.calendar.changeView('resourceTimelineDay', date)
              },
              0
            )
          }
        }

        this.reColorResources()

        // Znovu inicializovat tooltipy po změně pohledu
        setTimeout(() => {
          this.initializeTooltips()
        }, 100)
      },

      customButtons: {
        switchDay: {
          text: '',
          bootstrapFontAwesome: 'calendar'
        },
        closeAll: {
          text: this.$translate.text('sched_close_all'),
          click: () => {
            $('.fc-icon-minus-square').closest('.fc-expander-space.fc-expander').trigger('click', { reColorResources: false })
          }
        },
        openAll: {
          text: this.$translate.text('sched_expand_all'),
          click: () => {
            $('.fc-icon-plus-square').closest('.fc-expander-space.fc-expander').trigger('click', { reColorResources: false })
            $('.fc-icon-plus-square').closest('.fc-expander-space.fc-expander').trigger('click', { reColorResources: false })

            this.reColorResources()
          }
        },
        filterViewResource: {
          text: this.$translate.text('VIEW_RESOURCES'),
          bootstrapFontAwesome: 'cogs',
          active: true,
          click: async (e) => {
            e.preventDefault()
            e.stopPropagation()
            e.target.blur()

            const filterKey = 'view_resource'
            this.resourceFilters[filterKey] = +!this.resourceFilters[filterKey]

            await this.refreshData()
            await this.refreshResources()
            await this.calendar.refetchResources()
            this.reColorResources()
          }
        },
        filterViewActivity: {
          text: this.$translate.text('VIEW_ACTIVITY'),
          bootstrapFontAwesome: 'list-ul',
          click: async (e) => {
            e.preventDefault()
            e.stopPropagation()
            e.target.blur()

            const filterKey = 'view_activity'
            this.resourceFilters[filterKey] = +!this.resourceFilters[filterKey]

            await this.refreshData()
            await this.refreshResources()
            await this.calendar.refetchResources()
            this.reColorResources()
          }
        },
        filterViewUserGroup: {
          text: this.$translate.text('VIEW_USERGROUP'),
          bootstrapFontAwesome: 'group',
          click: async (e) => {
            e.preventDefault()
            e.stopPropagation()
            e.target.blur()

            const filterKey = 'view_user_group'
            this.resourceFilters[filterKey] = +!this.resourceFilters[filterKey]

            await this.refreshData()
            await this.refreshResources()
            await this.calendar.refetchResources()
            this.reColorResources()
          }
        },
        filterViewEndedTask: {
          text: this.$translate.text('VIEW_TASK_COMPLETED'),
          bootstrapFontAwesome: 'calendar-check-o',
          click: async (e) => {
            e.preventDefault()
            e.stopPropagation()
            e.target.blur()

            const filterKey = 'view_ended_task'
            this.eventFilters[filterKey] = +!this.eventFilters[filterKey]

            await this.refreshData()
            await this.refreshResources()
            await this.calendar.refetchResources()
            this.reColorResources()
          }
        },
        filterViewEndedActivity: {
          text: this.$translate.text('VIEW_ACTIVITY_COMPLETED'),
          bootstrapFontAwesome: 'flag-checkered',
          click: async (e) => {
            e.preventDefault()
            e.stopPropagation()
            e.target.blur()

            const filterKey = 'view_ended_activity'
            this.eventFilters[filterKey] = +!this.eventFilters[filterKey]

            await this.refreshData()
            await this.refreshResources()
            await this.calendar.refetchResources()
            this.reColorResources()
          }
        },
        toggleSchedule: {
          text: this.$translate.text('VIEW_TASK_TO_SCHEDULED'),
          bootstrapFontAwesome: 'calendar-plus-o',
          click: () => {
            this.showSchedule = !this.showSchedule
            this.refreshButtons()
          }
        }
      },
      eventMouseEnter: (info) => {
        clearTimeout(this.tooltipTimeout)
        if (info.event.extendedProps.entityCode && info.event.id) {
          this.tooltipTimeout = setTimeout(() => {
            this.tooltipRenderer.prepare(
              info.el,
              info.event.extendedProps.entityCode,
              info.event.id,
              (tippyInstance) => {
                tippyInstance.show()
              },
              (error) => this.handleApiError(error),
              this.$translate
            )
          }, 1000)
        }
      },
      eventMouseLeave: (info) => {
        clearTimeout(this.tooltipTimeout)
        if (info.el._tippy) {
          info.el._tippy.destroy()
        }
      },
      eventRender: (info) => {
        if (info.event.extendedProps && info.event.extendedProps.statusColor) {
          let html = ''

          const statusBadgeClass = info.event.extendedProps.statusBadge.IconClass
            ? info.event.extendedProps.statusBadge.IconClass
            : info.event.extendedProps.statusBadge.ValueClass
          const iconColor = info.event.extendedProps.statusBadge.IconClass ? info.event.extendedProps.statusBadge.ValueClass : null

          html += `<div class="fc-event-status" style="background: ${info.event.extendedProps.statusColor}; ${iconColor ? 'color: ' + iconColor : ''};">`
          html += `<span class="${statusBadgeClass}">`
          html += info.event.extendedProps.statusBadge.Value
          html += '</span>'
          html += '</div>'

          html += '<div class="fc-event-body">'
          html += '<div class="fc-event-title">'
          html += '<span class="text">'
          html += info.event.extendedProps.typeName
          html += '</span>'
          html += '</div>'

          html += `<div class="fc-event-content">`
          html += info.event.extendedProps.description.replace(/(?:\r\n|\r|\n)/g, '<br>')
          if (info.event.extendedProps.hasOwnProperty('badge') && info.event.extendedProps.badge) {
            const badgeClass = info.event.extendedProps.badge.IconClass
              ? info.event.extendedProps.badge.IconClass
              : info.event.extendedProps.badge.ValueClass

            html += '<span class=badge-wrapper>'
            html += `<span class="${badgeClass}">`
            html += info.event.extendedProps.badge.Value
            html += '</span>'
            html += '</span>'
          }
          html += '</div>'
          html += '</div>'

          html += '<div class="fc-resizer fc-start-resizer"></div>'
          html += '<div class="fc-resizer fc-end-resizer"></div>'

          info.el.innerHTML = html
        }
      },
      resourceRender: (info) => {
        const avatarData = info.resource.extendedProps.avatar
        const skillsData = info.resource.extendedProps.skills

        if (avatarData || skillsData) {
          let html = ''

          html += '<div class="resource">'

          if (avatarData) {
            html += `<div class="avatar-container"><img src="${avatarData.Value}" class="${avatarData.ImageClass}" alt="avatar"></div>`
          }

          html += '<div class="resource-info">'
          html += `<span class="title">${info.resource.title}</span>`

          if (skillsData) {
            html += `<span>${skillsData}</span>`
          }

          html += '</div>'
          html += '</div>'

          info.el.querySelector('.fc-cell-text').innerHTML = html
        }
      }
    })

    this.calendar.render()
    this.start = this.calendar.view.activeStart
    this.end = this.calendar.view.activeEnd

    $(document).on('click', '.fc-expander', (e, data) => {
      if (data && data.hasOwnProperty('reColorResources') && !data.reColorResources) {
        return
      }

      this.reColorResources()
    })
  },

  beforeDestroy () {
    clearInterval(this.autoRefresInterval)
    $(document).off('click', '.fc-expander')
  },

  computed: {
    computedEventId () {
      return this.eventId
    }
  },

  methods: {
    // ✅ Pomocná metoda pro inicializaci tooltipů - MUSÍ být v methods sekci
    initializeTooltips () {
      // Zrušit všechny existující tooltipy
      $('.fc-button[data-toggle="tooltip"]').tooltip('dispose')

      // Definice tooltipů pro jednotlivá tlačítka
      const tooltipMap = {
        'fc-filterViewResource-button': this.$translate.text('TT_VIEW_RESOURCES') || 'Zobrazit/skrýt zdroje',
        'fc-filterViewActivity-button': this.$translate.text('TT_VIEW_ACTIVITY') || 'Zobrazit/skrýt aktivity',
        'fc-filterViewUserGroup-button': this.$translate.text('TT_VIEW_USERGROUP') || 'Zobrazit/skrýt skupiny uživatelů',
        'fc-filterViewEndedTask-button': this.$translate.text('TT_VIEW_TASK_COMPLETED') || 'Zobrazit/skrýt ukončené úkoly',
        'fc-filterViewEndedActivity-button': this.$translate.text('TT_VIEW_ACTIVITY_COMPLETED') || 'Zobrazit/skrýt ukončené aktivity',
        'fc-toggleSchedule-button': this.$translate.text('TT_VIEW_TASK_TO_SCHEDULED') || 'Zobrazit/skrýt plán',
        'fc-switchDay-button': this.$translate.text('TT_SWITCH_DAY') || 'Změnit den',
        'fc-today-button': this.$translate.text('sched_today') || 'Dnes',
        'fc-prev-button': this.$translate.text('TT_PREV') || 'Předchozí',
        'fc-next-button': this.$translate.text('TT_NEXT') || 'Další'
      }

      // Aplikovat tooltipy na všechna tlačítka
      $('.fc-button').each(function () {
        const $btn = $(this)
        let tooltipText = null

        // Najít odpovídající tooltip podle tříd
        for (const [className, text] of Object.entries(tooltipMap)) {
          if ($btn.hasClass(className)) {
            tooltipText = text
            break
          }
        }

        if (tooltipText) {
          $btn.attr('data-toggle', 'tooltip')
            .attr('data-placement', 'top')
            .attr('title', tooltipText)
            .tooltip({
              placement: 'top',
              trigger: 'hover',
              container: 'body'
            })
        }
      })
    },

    /**
     * Zkontroluje zda-li jsou predana definicni data, pokud ne nacteje z API
     * @return {Promise<any>}
     * @private
     */
    initDef () {
      if (this.menuField) {
        return new Promise(resolve => {
          this.def = new Definition({ data: [this.menuField] })
          const args = {
            code: this.def._data.Fields[0].Code,
            idtEntityStructureFrom: this.def.idStructure
          }
          this.modalDefArgs = args
          DefinitionGetter
            .getDataDefinition(
              args,
              (def) => {
                this.gridDef = def
                resolve()
              }
              , (error) => { this.handleApiError(error) })
        })
      }

      const args = {
        code: this.page,
        idtEntityStructureFrom: this.idStructure
      }
      const success = (def) => {
        this.def = def

        const args = {
          code: this.def._data.Fields[0].Code,
          idtEntityStructureFrom: this.def.idStructure
        }
        DefinitionGetter
          .getDataDefinition(
            args,
            (def) => {
              this.gridDef = def
            }
            , (error) => { this.handleApiError(error) })
      }

      return DefinitionGetter
        .getDataDefinition(
          args, success, (error) => { this.handleApiError(error) })
    },

    /**
     *
     * @param eventValueObject {SchedulerEventValueObject}
     * @param eventType
     */
    async refreshData (eventValueObject = null) {
      const top = $(window).scrollTop()
      if (eventValueObject) {
        this.calendar.getEvents().forEach(event => {
          if (event.id == eventValueObject.id) {
            event.remove()
          }
        })
      }

      const resourcesMap = {}
      this.resources.items.forEach(resource => {
        if (!resourcesMap[resource.resourceTable]) {
          resourcesMap[resource.resourceTable] = []
        }

        resourcesMap[resource.resourceTable].push(resource.idUserGroup)
      })

      this.eventCollection = await SchedulerResource.getEvents(
        DatetimeParser.dateObjectToMMDDYYY(this.start),
        DatetimeParser.dateObjectToMMDDYYY(this.end),
        resourcesMap,
        this.eventFilters.view_ended_task,
        this.eventFilters.view_ended_activity
      )
      this.calendar.getEventSources().forEach((resource) => {
        resource.remove()
      })
      this.calendar.addEventSource(this.eventCollection.toCalendarObjects(this.eventFilters))
      $(window).scrollTop(top)
      this.dragging()
      this.taskEventCalendar = undefined
      this.oldCalendarEvent = undefined
      this.refreshButtons()
      this.$emit('dataRefreshed')
    },

    async refreshResources () {
      this.resources = await SchedulerResource.getResources(
        this.resourceFilters.view_resource,
        this.resourceFilters.view_activity,
        this.resourceFilters.view_user_group,
        this.resourceFilters.search_keyword
      )
    },

    setEventId (eventId) {
      this.$store.commit('setEventId', eventId)
    },

         refreshButtons () {
      const elmViewResource = $('.fc-filterViewResource-button')
      if (!this.resourceFilters.view_resource) {
        elmViewResource.removeClass('filtr-aktivni')
        elmViewResource.addClass('filtr-neaktivni')
        elmViewResource.focusout()
      } else {
        elmViewResource.addClass('filtr-aktivni')
        elmViewResource.removeClass('filtr-neaktivni')
      }

      const elmFilterViewActivity = $('.fc-filterViewActivity-button')
      if (!this.resourceFilters.view_activity) {
        elmFilterViewActivity.removeClass('filtr-aktivni')
        elmFilterViewActivity.addClass('filtr-neaktivni')
        elmFilterViewActivity.focusout()
      } else {
        elmFilterViewActivity.addClass('filtr-aktivni')
        elmFilterViewActivity.removeClass('filtr-neaktivni')
      }

      const elmFilterViewUserGroup = $('.fc-filterViewUserGroup-button')
      if (!this.resourceFilters.view_user_group) {
        elmFilterViewUserGroup.removeClass('filtr-aktivni')
        elmFilterViewUserGroup.addClass('filtr-neaktivni')
        elmFilterViewUserGroup.focusout()
      } else {
        elmFilterViewUserGroup.addClass('filtr-aktivni')
        elmFilterViewUserGroup.removeClass('filtr-neaktivni')
      }

      const elmFilterViewEndedTask = $('.fc-filterViewEndedTask-button')
      if (this.eventFilters.view_ended_task) {
        elmFilterViewEndedTask.addClass('filtr-aktivni')
        elmFilterViewEndedTask.removeClass('filtr-neaktivni')
      } else {
        elmFilterViewEndedTask.removeClass('filtr-aktivni')
         elmFilterViewEndedTask.addClass('filtr-neaktivni')
        elmFilterViewEndedTask.focusout()
      }

      const elmFilterViewEndedActivity = $('.fc-filterViewEndedActivity-button')
      if (this.eventFilters.view_ended_activity) {
        elmFilterViewEndedActivity.addClass('filtr-aktivni')
        elmFilterViewEndedActivity.removeClass('filtr-neaktivni')
      } else {
        elmFilterViewEndedActivity.removeClass('filtr-aktivni')
        elmFilterViewEndedActivity.addClass('filtr-neaktivni')
        elmFilterViewEndedActivity.focusout()
      }

      const elmToggleSchedule = $('.fc-toggleSchedule-button')
      if (this.showSchedule) {
        elmToggleSchedule.addClass('filtr-aktivni')
        elmToggleSchedule.removeClass('filtr-neaktivni')
      } else {
        elmToggleSchedule.removeClass('filtr-aktivni')
        elmToggleSchedule.addClass('filtr-neaktivni')
        elmToggleSchedule.focusout()
      }
    },

    /**
     *
     * @param eventValueObject {SchedulerEventValueObject}
     */
    async removeEventListener (eventValueObject) {
      await this.refreshData(eventValueObject)
    },

    /**
     *
     * @param eventValueObject {SchedulerEventValueObject}
     */
    async updateEventListener (eventValueObject) {
      await this.refreshData(eventValueObject)
    },

    /**
     *
     * @param eventValueObject {SchedulerEventValueObject}
     */
    async cancelListener (eventValueObject) {
      await this.refreshData(eventValueObject)
    },
    async rowClick (row) {
      this.eventValueObject = SchedulerEventValueObject.fromRowData(row)
      this.modalDefArgs = {
        code: this.def._data.Fields[0].Code,
        idtEntityStructureFrom: this.def.idStructure
      }
      this.$modal.show('test')
    },

    _initAutoRefresh () {
      this.autoRefresInterval = setInterval(async () => {
        await this.refreshData()
        await this.refreshResources()
        await this.calendar.refetchResources()
        this.reColorResources()
      }, this.config.refreshEventsData)
    },

    toggleListener ($item) {
      const resourceId = $item.data('resource-id').toString()

      if (resourceId.includes('l')) {
        $item.addClass('disabled')
      }

      const resource = this.calendar.getResources().filter((item) => { return item.id === resourceId })[0]
      if (resource && resource.extendedProps && resource.extendedProps.color) {
        $item.css('background', resource.extendedProps.color)
        $item.find('.fc-cell-text').css('color', resource.extendedProps.fontColor)
      }
    },

    reColorResources () {
      $('.fc-rows tr[data-resource-id]').each((i, item) => {
        this.toggleListener($(item))
      })
    },

    dragging () {
      $(document).off('mousedown', '.fc-scroller')

      let pageX_Drag, pageY_Drag
      const disableDragSelector = '.fc-event,.form-control,.some-other-class-here-maybe'

      $(document).on('mousedown', '.fc-scroller', function (e) {
        // prevent drag from happening if we click on certain things
        const dragDisabledElms = $(e.target).parents(disableDragSelector).addBack(disableDragSelector)
        if (dragDisabledElms.length) {
          return
        }

        pageX_Drag = e.pageX
        pageY_Drag = e.pageY

        $(window).off('mousemove', __mouseMove_Drag)
        $(window).on('mousemove', __mouseMove_Drag)
      })
      $(window).on('mouseup', __mouseUp_Drag)

      function __mouseUp_Drag () {
        $(window).off('mousemove', __mouseMove_Drag)
      }

      function __mouseMove_Drag (evt) {
        const offsetX = pageX_Drag - evt.pageX
        const offsetY = pageY_Drag - evt.pageY

        $(document).find('.fc-scroller').each(function () {
          const scroller = $(this)
          const newX = scroller.scrollLeft() + offsetX
          const newY = scroller.scrollTop() + offsetY

          scroller.scrollLeft(newX)
          scroller.scrollTop(newY)
        })

        $(document).find('.fc-head td.fc-time-area').each(function () {
          const scroller = $(this)
          const newX = scroller.scrollLeft() + offsetX
          const newY = scroller.scrollTop() + offsetY

          scroller.scrollLeft(newX)
          scroller.scrollTop(newY)
        })

        pageX_Drag = evt.pageX
        pageY_Drag = evt.pageY
      }
    },

    modalClosed () {
      this.$refs.grid._initData()
    }
  }
}
</script>

<style>
@import '~@fullcalendar/core/main.css';
@import '~@fullcalendar/timeline/main.css';
@import '~@fullcalendar/resource-timeline/main.css';
@import '~@fullcalendar/bootstrap/main.css';








.v--modal-overlay {
  z-index: 99999;
  background: rgba(0, 0, 0, 0.5);
}

.row-scheduler {
  margin: 10px 10px;
}

.row.row-scheduler.row-kpi .panel-body {
  padding: 10px 0px;
}

.row.row-scheduler .panel-body {
  padding-top: 20px;
  background: #FFF;
  border-radius: 5px;
}

.row.row-scheduler:not(.row-kpi) .panel-body,
.row.row-scheduler:not(.row-kpi) .scheduler-wrapper {
  height: calc(100vh - 0px);
  /* overflow-y: scroll; */
  padding-top: 0px;
}

.row.row-scheduler:not(.row-kpi) .panel-body .panel-body,
.row.row-scheduler:not(.row-kpi) .panel-body .scheduler-wrapper {
  overflow-y: scroll;
}

.vue-component-holder.dashboard .row.row-scheduler:not(.row-kpi) .panel-body,
.vue-component-holder.dashboard .row.row-scheduler:not(.row-kpi) .scheduler-wrapper {
  height: calc(100vh - 200px);
}

.vue-component-holder.dashboard .row.row-scheduler:not(.row-kpi) .panel-body {
  height: calc(90vh - 45px);
}

.vue-component-holder.dashboard .row.row-scheduler:not(.row-kpi) .panel .panel-body {
  height: auto;
}

.scheduler-wrapper {
  margin: 20px;
}

h4.scheduler-tasks {
  margin: 10px 3px 28px !important;
}

.scheduler-wrapper h2 {
  font-weight: 500;
  font-size: 17px;
}

.fc-event, .fc-event-dot {
  background-color: #4598cb;
  flex-direction: row;
}

.fc-event-status {
  border-right: 1px solid #b6b6b6;
  display: flex;
  justify-content: center;
  padding: 5px;
}

.fc-event-body {
  flex-grow: 1;
  background-color: white;
}

.fc-resource-area .fc-cell-content .fc-cell-text .resource {
  color: #37474f;
}

.fc-resource-area .fc-cell-content .fc-cell-text .resource .title {
  font-weight: 600;
}

.fc-resource-area .fc-cell-content .fc-cell-text .resource {
  display: inline-flex;
  min-height: 60px;
  flex-wrap: nowrap;
  align-items: center;
  gap: 12px;
}

.fc-resource-area .fc-cell-content .fc-cell-text .resource .resource-info {
  display: flex;
  flex-direction: column;
}

.fc-left, .fc-center, .fc-center div, fc-right {
  display: flex;
  align-items: center;
}

.fc-center .fc-next-button {
  margin-left: 10px;
}

.fc-center .fc-prev-button {
  margin-right: 10px;
}

.fc-center .fc-switchDay-button {
  margin: 0 10px;
}

.fc-time-area .fc-sat,
.fc-time-area .fc-sun {
  background: #d2d2d2;
}

.fc-timeline .fc-divider {
  display: none;
}

#external-events .fc-event {
  background: #8c8c8c;
  border: none;
  margin: 5px 0;
  padding: 5px 10px;
  cursor: move;
  display: flex;
  justify-content: space-between;
}

#external-events .fc-event .title {
  display: flex;
  justify-content: center;
  align-items: center;
}

#external-events .products-list-options {
  padding: 15px 0;
  top: 40px;
}

#external-events .products-wrapper {
  padding-top: 0;
}

#external-events .search-group::before {
  position: absolute;
  left: 10px;
}

#external-events .search-group .form-control {
  width: 100%;
}

#external-events h1 {
  padding-top: 10px;
    top: 0;
  position: sticky;
  z-index: 99;
  background-color: #fff;
}

#external-events .table-responsive .products {
  min-width: auto;
}

.popper,
.tooltip {
  position: absolute;
  z-index: 9999;
  background: #FFC107;
  color: black;
  width: 150px;
  border-radius: 3px;
  box-shadow: 0 0 2px rgba(0, 0, 0, 0.5);
  padding: 10px;
  text-align: center;
  opacity: 1;
}

.style5 .tooltip {
  background: #1E252B;
  color: #FFFFFF;
  max-width: 200px;
  width: auto;
  font-size: .8rem;
  padding: .5em 1em;
}

.popper .popper__arrow,
.tooltip .tooltip-arrow {
  width: 0;
  height: 0;
  border-style: solid;
  position: absolute;
  margin: 5px;
}

.tooltip .tooltip-arrow,
.popper .popper__arrow {
  border-color: #FFC107;
}

.style5 .tooltip .tooltip-arrow {
  border-color: #1E252B;
}

.popper[x-placement^="top"],
.tooltip[x-placement^="top"] {
  margin-bottom: 5px;
}

.popper[x-placement^="top"] .popper__arrow,
.tooltip[x-placement^="top"] .tooltip-arrow {
  border-width: 5px 5px 0 5px;
  border-left-color: transparent;
  border-right-color: transparent;
  border-bottom-color: transparent;
  bottom: -5px;
  left: calc(50% - 5px);
  margin-top: 0;
  margin-bottom: 0;
}

.popper[x-placement^="bottom"],
.tooltip[x-placement^="bottom"] {
  margin-top: 5px;
}

.tooltip[x-placement^="bottom"] .tooltip-arrow,
.popper[x-placement^="bottom"] .popper__arrow {
  border-width: 0 5px 5px 5px;
  border-left-color: transparent;
  border-right-color: transparent;
  border-top-color: transparent;
  top: -5px;
  left: calc(50% - 5px);
  margin-top: 0;
  margin-bottom: 0;
}

.tooltip[x-placement^="right"],
.popper[x-placement^="right"] {
  margin-left: 5px;
}

.popper[x-placement^="right"] .popper__arrow,
.tooltip[x-placement^="right"] .tooltip-arrow {
  border-width: 5px 5px 5px 0;
  border-left-color: transparent;
  border-top-color: transparent;
  border-bottom-color: transparent;
  left: -5px;
  top: calc(50% - 5px);
  margin-left: 0;
  margin-right: 0;
}

.popper[x-placement^="left"],
.tooltip[x-placement^="left"] {
  margin-right: 5px;
}

.popper[x-placement^="left"] .popper__arrow,
.tooltip[x-placement^="left"] .tooltip-arrow {
  border-width: 5px 0 5px 5px;
  border-top-color: transparent;
  border-right-color: transparent;
  border-bottom-color: transparent;
  right: -5px;
  top: calc(50% - 5px);
  margin-left: 0;
  margin-right: 0;
}

.alert-info {
  background-color: #88c562 !important;
  border-color: #bee5eb !important;
}

.fc-timeline .fc-divider div {
  background: #f1f4f5;
}

.fc-timeline .fc-resource-area .fc-content .fc-divider div {
  height: 23px !important;
  border-bottom: 1px solid #ffffff;
}

.fc-head .fc-time-area, .fc-head .fc-resource-area {
  top: 19px !important;
}

.fc-timeline .fc-resource-area .fc-content .fc-divider div .fc-cell-text {
  color: #868686;
}

.fc-timeline .fc-content .fc-divider div {
  height: 24px !important;
  cursor: no-drop;
}

.fc-timeline .fc-divider div .fc-cell-content {
  padding: 3px 0 0 10px;
}

.max-height-scroll {

}

.fc-rows tr.disabled {
  background: #bbbbbb;
  cursor: no-drop;
}

.fc-rows tr[data-resource-id="9"] {
  background: #98cc1a36;
}

td.fc-resource-area .fc-cell-content {
  border-right: 3px solid #d2d2d2;
  height: 100%;
}

.fc-rows tr.disabled div {
  max-height: 26px !important;
}

.fc-body .fc-resource-area tr.disabled .fc-cell-content {
  padding-top: 3px;
  padding-bottom: 5px;
}

.fc-toolbar {
  flex-wrap: wrap;
  row-gap: 10px
}

.fc-toolbar.fc-header-toolbar {
  position: sticky;
  top: 0px;
  background: #fff;
  z-index: 99;
  padding: 10px 0;
  margin-bottom: 0.5em;
}

.fc-head .fc-time-area,
.fc-head .fc-resource-area {
  position: sticky;
  top: 57px;
  z-index: 999999999;
  background: #FFF;
  border-top: 0px;
  border-bottom: 0px;
}

.fc-head .fc-time-area .fc-scroller-clip,
.fc-head .fc-resource-area .fc-scroller-clip {
  border-top: 1px solid #e4eaec;
}

.fc-head .fc-time-area .fc-content,
.fc-head .fc-resource-area .fc-content {
  border-bottom: 1px solid #e4eaec;
}

.fc-body .fc-time-area,
.fc-body .fc-resource-area {
  border-top: 0px;
}

.fc table {
  border-top: 0px;
}

.fc-bootstrap a.fc-event:not([href]):not([tabindex]) {
  overflow: hidden;
  /*flex-direction: column;*/
  font-size: 10px;
  padding: 0;
  border: 1px solid #b6b6b6;
  border-radius: 3px;
}

.fc-bootstrap a.fc-event:not([href]):not([tabindex]) .fc-event-title {
  padding: 2px 5px 3px;
}

.fc-bootstrap a.fc-event:not([href]):not([tabindex]) .fc-event-content {
  padding: 2px 5px;
  line-height: 11px;
  border-top: none;
  color: #37474f;
}

.fc-bootstrap a.fc-event:not([href]):not([tabindex]) .fc-event-title .badge {
  margin-right: 5px;
}

.fc-bootstrap a.fc-event:not([href]):not([tabindex]) .fc-event-content .badge-wrapper {
  display: block;
  margin: 3px 0;
}

.fc-timeline-event.fc-not-start:before, .fc-timeline-event.fc-not-end:after {
  position: absolute;
  top: 4px;
  left: -2px;
}

.fc-time-area .fc-content {
  cursor: grab;
}

.fc-resource-area .fc-icon {
  display: inline-block;
  width: 0px;
}

.fc-resource-area .fc-icon:first-child {
  width: 1rem;
}

.fc-resource-area .fc-expander .fc-icon {
  display: inline-block;
  width: 1rem;
}

.fc-event-title .icon:before,
.fc-event-content .icon:before {
  margin-right: 3px;
}

.fc-event-title {
  color: #000000;
}

.fc-timeline-event {
  min-width: 20px;
}

@media (max-width: 768px) {
  #external-events {
    margin-top: 20px;
  }

  .row-scheduler .pl-0 {
    padding-left: 1.0715rem !important;
  }

  .fc-left {
    margin-bottom: 15px;
  }

  .fc-resource-area {
    width: 35% !important;
  }
}

@media (max-width: 420px) {
  .fc-resource-area {
    width: 50% !important;
  }

  .fc-right {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
  }

  .fc-right .btn-group {
    margin-bottom: 5px;
  }

  .fc-header-toolbar.fc-toolbar > .fc-right > :not(:first-child) {
    margin-left: 0;
  }
}

#resource-search-filter,
#resource-search-filter::placeholder,
#resource-search-filter::-webkit-input-placeholder,
#resource-search-filter:-moz-placeholder,
#resource-search-filter::-moz-placeholder,
#resource-search-filter:-ms-input-placeholder {
  color: #828282 !important;
}



.filtr-aktivni {

  background-color: #4598cb!important;
  border-color: #4598cb!important;
}
.filtr-neaktivni {

  background-color: #828282!important;
  border-color: #828282!important;
}





</style>
